export default __webpack_public_path__ + "static/media/Contact page image 3.73f052c0.png";